module.exports = __webpack_public_path__ + "img/30.1cbcf5c0.png";